import SEO from '../components/SEO/SEO';
import Clients from './../components/BrandSection/Clients';
import ContactLayout from '../components/ContactPageComponents/PagesComponents/ContactLayout';
import { usePageSEO } from '../hooks/usePageSEO';

const Contact = () => {
    const seo = usePageSEO('contact');

    return (
        <>
            <SEO
                title={seo.title}
                description={seo.description}
                keywords={seo.keywords}
                type={seo.type}
                noIndex={seo.noIndex}
                noFollow={seo.noFollow}
            />
            <ContactLayout />
            <Clients />
        </>
    );
};

export default Contact;